export default __webpack_public_path__ + "static/media/big_banner.3d271669.png";